import './style.scss';
import React from 'react';
import { Link } from 'react-router-dom';
import Text from '../text';

function Container(props) {
  return props.href ? (
    <Link to={props.href}>{props.children}</Link>
  ) : (
    props.children
  );
}

function TextOverImage(props) {
  const imageStyle = props.image
    ? { backgroundImage: `url(${props.image})` }
    : {};
  return (
    <Container href={props.href}>
      <div className="text-over-image">
        <div className="text-over-image__image" style={imageStyle} />
        <Text className="text-over-image__text" shadow size="xl" weight="med">
          {props.text}
        </Text>
      </div>
    </Container>
  );
}

export default TextOverImage;



// WEBPACK FOOTER //
// ./shared/components/ui/textOverImage/index.js